import { render, staticRenderFns } from "./SubscriptionItemDetails.vue?vue&type=template&id=61be2626&"
import script from "./SubscriptionItemDetails.vue?vue&type=script&lang=js&"
export * from "./SubscriptionItemDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports